<template>
  <div class="userinfo member-table-container container_media">
    <div class="rowShow title-row">
      <p class="card-title">个人信息</p>
    </div>

    <div class="content myCenter_table">
      <div class="info-layout">
        <div class="operation-container info-section">
          <p class="section-title">基本信息</p>
          <el-form :model="infoForm" label-width="100px">
            <el-form-item label="用户名称">
              <div class="name-input-group">
                <el-input
                  v-model="infoForm.name"
                  size="small"
                  placeholder="请输入用户名称"
                  clearable
                  maxlength="20"
                  @keyup.enter.native="handleSaveName"
                />
                <el-button
                  type="download"
                  size="small"
                  plain
                  class="save-name-btn"
                  :disabled="!canSaveName"
                  :loading="saveNameLoading"
                  @click="handleSaveName"
                >
                  保存
                </el-button>
              </div>
            </el-form-item>
            <el-form-item v-if="showPhone" label="手机号">
              <el-input
                v-model="infoForm.phone"
                :disabled="!!(userInfo && userInfo.phone)"
                size="small"
                placeholder="请输入手机号"
                maxlength="11"
                clearable
              />
            </el-form-item>
            <el-form-item v-if="showEmail" label="邮箱">
              <el-input
                v-model="infoForm.email"
                :disabled="!!(userInfo && userInfo.email)"
                size="small"
                placeholder="请输入邮箱"
                clearable
              />
            </el-form-item>
            <el-form-item label="最后登录">
              <el-input
                :value="formattedLoginTime"
                disabled
                size="small"
                placeholder="-"
              />
            </el-form-item>
          </el-form>
        </div>

        <div class="operation-container password-section">
          <p class="section-title">修改密码</p>
          <el-form
            ref="passwordForm"
            :model="passwordForm"
            :rules="passwordRules"
            label-width="100px"
            @submit.native.prevent
          >
            <el-form-item label="新密码" prop="password">
              <el-input
                v-model="passwordForm.password"
                type="password"
                size="small"
                placeholder="请输入新密码"
                show-password
                clearable
              />
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input
                v-model="passwordForm.confirmPassword"
                type="password"
                size="small"
                placeholder="请再次输入新密码"
                show-password
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="download"
                size="small"
                plain
                :loading="submitLoading"
                @click="handleChangePassword"
              >
                修改密码
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseDate } from '@/filters'
import { updateUserName, updateUserPassword } from '@/api/user'
import { getToken } from '@/utils/author'

export default {
  name: 'UserInfo',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }
    return {
      infoForm: {
        name: '',
        phone: '',
        email: '',
        login_time: ''
      },
      passwordForm: {
        password: '',
        confirmPassword: ''
      },
      passwordRules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, trigger: 'blur', validator: validateConfirmPassword }
        ]
      },
      submitLoading: false,
      saveNameLoading: false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    showPhone() {
      return !!(this.userInfo && this.userInfo.phone)
    },
    showEmail() {
      return !!(this.userInfo && this.userInfo.email)
    },
    formattedLoginTime() {
      const { login_time } = this.infoForm
      if (!login_time) return '-'
      return parseDate(login_time.replace(/-/g, '/'), 'yyyy-MM-dd HH:mm:ss')
    },
    canSaveName() {
      const name = (this.infoForm.name || '').trim()
      const originalName = ((this.userInfo && this.userInfo.name) || '').trim()
      return !!name && name !== originalName
    }
  },
  watch: {
    userInfo: {
      handler: 'syncUserInfo',
      immediate: true,
      deep: true
    }
  },
  methods: {
    syncUserInfo() {
      if (!this.userInfo) return
      const { name = '', phone = '', email = '', login_time = '' } = this.userInfo
      this.infoForm = {
        name,
        phone,
        email,
        login_time
      }
    },
    async handleSaveName() {
      if (!this.canSaveName) return
      if (!getToken()) {
        this.$message.warning('请先登录')
        return
      }
      const name = (this.infoForm.name || '').trim()
      if (!name) {
        this.$message.warning('请输入用户名称')
        return
      }
      try {
        this.saveNameLoading = true
        const res = await updateUserName({ name })
        if (res.code === 0) {
          this.$message.success('昵称修改成功')
          await this.$store.dispatch('user/getUserInfo')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.saveNameLoading = false
      }
    },
    handleChangePassword() {
      if (!getToken()) {
        this.$message.warning('请先登录')
        return
      }
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return
        const { password, confirmPassword } = this.passwordForm
        try {
          this.submitLoading = true
          const res = await updateUserPassword({
            password,
            password_two: confirmPassword
          })
          if (res.code === 0) {
            this.$message.success('密码修改成功')
            this.passwordForm.password = ''
            this.passwordForm.confirmPassword = ''
            this.$refs.passwordForm.clearValidate()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.userinfo {
  padding: 40px 0;

  .title-row {
    margin: 10px 0 40px;
  }

  .rowShow {
    display: flex;
    align-items: center;
  }

  .card-title {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
    margin: 0;
  }

  .info-layout {
    display: flex;
    align-items: flex-start;
    gap: 48px;
  }

  .operation-container {
    flex: 1;
    min-width: 0;

    .section-title {
      margin: 0 0 16px;
      font-size: 15px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }

    .el-input {
      width: 100%;
      max-width: 300px;
      height: 30px;
      display: block;
    }

    .name-input-group {
      display: inline-flex;
      align-items: stretch;
      max-width: 364px;
      vertical-align: top;

      .el-input {
        flex: 1;
        width: 236px;
        max-width: none;
        height: auto;
        display: block;

        /deep/ .el-input__inner {
          height: 32px;
          line-height: 32px;
          border-radius: 4px 0 0 4px;
        }
      }

      .save-name-btn {
        flex-shrink: 0;
        height: 32px;
        line-height: 30px;
        width: 64px;
        padding: 0;
        margin: 4px 0 0 0px;
        border-radius: 0 4px 4px 0;
        box-sizing: border-box;
      }
    }

    .el-button {
      height: 30px;
      width: 100px;
    }

    /deep/ .el-form {
      .el-form-item {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .el-form-item__label {
          font-size: 15px;
          font-weight: 500;
          text-align: left;

          &::before {
            content: '';
          }
        }
      }
    }
  }

  .password-section {
    padding-left: 48px;
    border-left: 1px solid rgba(0, 0, 0, 0.06);
  }

  .content {
    @include size(100%, auto);
    padding: 24px 36px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
    margin-top: 0;
  }
}
</style>
